import { setLogLevel, disableLogUpload } from 'agora-rtc-sdk-ng/esm'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { ThemeProvider } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Quill from 'quill'
import dayjs from 'dayjs'

import CombinedRoutes from './shared/components/routes/CombinedRoutes'

// Stores
import DownloadStatusListStore, { DownloadStatusListProvider } from './alive-academics/store/downloadstatuslistdialog.store'
import ResumeBuilderStore, { ResumeBuilderStoreProvider } from './alive-academics/store/resumebuilder.store'
import StudyMaterialStore, { StudyMaterialStoreProvider } from "./alive-academics/store/studymaterial.store"
import OrganizationStore, { OrganizationStoreProvider } from "./alive-academics/store/organization.store"
import NotificationStore, { NotificationStoreProvider } from "./alive-academics/store/notification.store"
import DiscussionForumStore, { DiscussionForumProvider } from './alive-academics/store/discussionforum.store'
import OnlineCourseStore, { OnlineCourseProvider } from './alive-academics/store/onlinecourse.store'
import AssignmentStore, { AssignmentStoreProvider } from "./alive-academics/store/assignment.store"
import SettingsStore, { SettingsStoreProvider } from './alive-academics/store/settings.store'
import SimbaAIStore, { SimbaAIStoreProvider } from './alive-academics/store/simbaai.store'
import RoomStore, { RoomStoreProvider } from "./alive-academics/store/room.store"
import AuthStore, { AuthStoreProvider } from "./alive-academics/store/auth.store"
import UserStore, { UserStoreProvider } from "./alive-academics/store/user.store"
import ExamStore, { ExamStoreProvider } from './alive-academics/store/exam.store'
import ChatStore, { ChatStoreProvider } from './alive-academics/store/chat.store'
import QuizStore, { QuizAndQuestionbankStoreProvider } from './alive-academics/store/quiz.store'

import OnlineSessionsStoreInstance, { OnlineSessionsStoreProvider } from './alive-academics/store/onlinesessions.store'
import LiveSessionStore, { LiveSessionStoreProvider } from './alive-academics/store/livesessions.store'
import ThemeContextProvider, { useThemeContext } from './shared/contexts/theme.context'
import FallbackErrorBoundary from './shared/components/error-boundaries/FallbackErrorBoundary'
// import themes from './alive-academics/themes/themes'
import themes from './shared/themes/themes'
import { ErrorBoundary } from 'react-error-boundary'


setLogLevel( 4 )
disableLogUpload()

const Video = Quill.import( 'formats/video' )
const Link = Quill.import( 'formats/link' )

class CustomVideo extends Video {
  static create ( value ) {
    const node = super.create( value )

    const video = document.createElement( 'video' )
    video.setAttribute( 'controls', true )
    video.setAttribute( 'type', 'video/*' )
    video.setAttribute( 'style', 'max-height: 200px;object-fit: contain;' )
    video.setAttribute( 'src', this.sanitize( value ) )
    node.appendChild( video )

    return node
  }

  static sanitize ( url ) {
    return Link.sanitize( url )
  }
}
CustomVideo.blotName = 'video'
CustomVideo.className = 'ql-video-custom'
CustomVideo.tagName = 'DIV'

Quill.register( 'formats/video', CustomVideo )

window.dayjs = dayjs
dayjs.extend( localizedFormat )

const AppProvider = () => {

  const { theme } = useThemeContext()

  return (
    <ThemeProvider theme={themes[theme]}>
      {/* <AutoAttendence /> */}

      <>
        <AuthStoreProvider store={AuthStore}>
          <UserStoreProvider store={UserStore}>
            <OrganizationStoreProvider store={OrganizationStore}>
              <RoomStoreProvider store={RoomStore}>
                <StudyMaterialStoreProvider store={StudyMaterialStore}>
                  <OnlineCourseProvider store={OnlineCourseStore}>
                    <AssignmentStoreProvider store={AssignmentStore}>
                      <NotificationStoreProvider store={NotificationStore}>
                        <ExamStoreProvider store={ExamStore}>
                          <ResumeBuilderStoreProvider store={ResumeBuilderStore}>
                            <ChatStoreProvider store={ChatStore}>
                              <DownloadStatusListProvider store={DownloadStatusListStore}>
                                <SettingsStoreProvider store={SettingsStore}>
                                  <DiscussionForumProvider store={DiscussionForumStore}>
                                    <QuizAndQuestionbankStoreProvider store={QuizStore}>
                                      <LiveSessionStoreProvider store={LiveSessionStore}>
                                        <SimbaAIStoreProvider store={SimbaAIStore}>
                                          <OnlineSessionsStoreProvider store={OnlineSessionsStoreInstance}>
                                            <ErrorBoundary FallbackComponent={FallbackErrorBoundary}>
                                              <CombinedRoutes />
                                            </ErrorBoundary>
                                            <ToastContainer position='bottom-left' autoClose={20000} hideProgressBar closeOnClick theme={theme === 'dark' ? 'light' : 'dark'} style={{ fontSize: "12px", zIndex: 100000000 }} />
                                          </OnlineSessionsStoreProvider>
                                        </SimbaAIStoreProvider>
                                      </LiveSessionStoreProvider>
                                    </QuizAndQuestionbankStoreProvider>
                                  </DiscussionForumProvider>
                                </SettingsStoreProvider>
                              </DownloadStatusListProvider>
                            </ChatStoreProvider>
                          </ResumeBuilderStoreProvider>
                        </ExamStoreProvider>
                      </NotificationStoreProvider>
                    </AssignmentStoreProvider>
                  </OnlineCourseProvider>
                </StudyMaterialStoreProvider>
              </RoomStoreProvider>
            </OrganizationStoreProvider>
          </UserStoreProvider>
        </AuthStoreProvider>

      </>
    </ThemeProvider>
  )
}


function App () {

  return (
    <ThemeContextProvider>
      <AppProvider />
    </ThemeContextProvider>
  )
}

export default App

